<div
  class="accueil-page"
  [style.--vd-px.px]="heroParallax().x"
  [style.--vd-py.px]="heroParallax().y"
>

  <!-- ═══════════════════════════════════════════════════════════════════
       0. ONBOARDING HERO (compte en cours de configuration)
       Caché automatiquement quand l'onboarding est complet ou masqué.
       ═══════════════════════════════════════════════════════════════════ -->
  <app-onboarding-hero></app-onboarding-hero>

  <!-- ═══════════════════════════════════════════════════════════════════
       1. HERO IMMERSIF
       ═══════════════════════════════════════════════════════════════════ -->
  <header class="hero section-enter" role="banner">
    <!-- Aurora orbs -->
    <div class="orb orb-1" aria-hidden="true"></div>
    <div class="orb orb-2" aria-hidden="true"></div>
    <div class="orb orb-3" aria-hidden="true"></div>
    <div class="hero-noise" aria-hidden="true"></div>
    <div class="hero-grid" aria-hidden="true"></div>

    <!-- Confetti (rare) -->
    <div *ngIf="showConfetti()" class="confetti-layer" aria-hidden="true">
      <span *ngFor="let i of confettiParticles" class="confetti-particle" [attr.data-i]="i"></span>
    </div>

    <div class="hero-inner">
      <!-- Colonne gauche : salutation + météo + composer + CTAs -->
      <div class="hero-left">
        <div class="hero-eyebrow">
          <span class="live-dot" [class.stale]="liveStatus() === 'stale'"></span>
          <span class="hero-eyebrow-text">
            {{ (isAdmin() ? 'accueil.role.admin' : isVendor() ? 'accueil.role.vendor' : 'accueil.role.team') | transloco }}
          </span>
          <span class="live-pill" [class.stale]="liveStatus() === 'stale'">
            {{ (liveStatus() === 'stale' ? 'accueil.live.stale' : 'accueil.live.live') | transloco }}
          </span>
          <span class="updated-meta" [title]="'accueil.live.updated_title' | transloco: { relative: relativeUpdated() }">
            <span class="material-icons-outlined">schedule</span>
            {{ relativeUpdated() }}
          </span>
        </div>

        <h1 class="hero-title">
          <span class="hero-emoji material-icons-outlined">{{ timeOfDayIcon() }}</span>
          {{ greetingKey() | transloco }}<ng-container *ngIf="userFirstname()">,
            <span class="vd-gradient-text">{{ userFirstname() }}</span></ng-container>
        </h1>
        <p class="hero-weather">{{ weatherKey() | transloco: weatherParams() }}</p>

        <!-- Composer IA -->
        <form class="hero-composer" (submit)="$event.preventDefault(); submitHeroComposer()">
          <span class="material-icons-outlined composer-icon">auto_awesome</span>
          <input
            type="text"
            [ngModel]="composerValue()"
            (ngModelChange)="composerValue.set($event)"
            (keydown)="onComposerKeydown($event)"
            [placeholder]="heroPrompts[heroPromptIdx()] | transloco"
            name="hero-composer"
            autocomplete="off"
            [attr.aria-label]="'accueil.composer.aria_label' | transloco"
          />
          <button type="submit" class="composer-send" [disabled]="!composerValue().trim()" [title]="'accueil.composer.send_title' | transloco">
            <span class="material-icons-outlined">arrow_forward</span>
          </button>
        </form>

        <!-- Quick CTA pills -->
        <div class="hero-pills">
          <button class="pill" type="button" (click)="goToFirstSite()">
            <span class="material-icons-outlined">language</span>
            <span>{{ 'accueil.pills.my_sites' | transloco }}</span>
            <span class="pill-badge" *ngIf="mySites().length > 0">{{ mySites().length }}</span>
          </button>
          <button class="pill pill-accent" type="button" (click)="goToNewSite()">
            <span class="material-icons-outlined">add_circle</span>
            <span>{{ 'accueil.pills.new_site' | transloco }}</span>
          </button>
          <button class="pill" type="button" (click)="goToInbox()">
            <span class="material-icons-outlined">forum</span>
            <span>{{ 'accueil.pills.inbox' | transloco }}</span>
            <span class="pill-badge pill-badge-danger" *ngIf="inboxUnreadCount() > 0">{{ inboxUnreadCount() }}</span>
          </button>
        </div>
      </div>

      <!-- Colonne droite : stat héros glassmorphism -->
      <aside class="hero-stat" [attr.aria-label]="'accueil.hero_stat.aria' | transloco">
        <div class="hero-stat-head">
          <span class="hero-stat-label">{{ 'accueil.hero_stat.label' | transloco }}</span>
          <span class="hero-stat-trend" *ngIf="yesterdayDelta() !== null"
                [class.up]="(yesterdayDelta() || 0) >= 0"
                [class.down]="(yesterdayDelta() || 0) < 0">
            <span class="material-icons-outlined">{{ (yesterdayDelta() || 0) >= 0 ? 'trending_up' : 'trending_down' }}</span>
            {{ 'accueil.hero_stat.delta_vs_yesterday' | transloco: {
              sign: ((yesterdayDelta() || 0) >= 0 ? '+' : ''),
              value: (yesterdayDelta() || 0).toFixed(0)
            } }}
          </span>
        </div>
        <div class="hero-stat-value">
          {{ formatMoney(heroAnimatedRevenue()) }}
        </div>
        <div class="hero-spark" *ngIf="heroSparkline().length > 1; else heroSparkSkeleton">
          <svg viewBox="0 0 220 56" preserveAspectRatio="none" class="spark-svg">
            <defs>
              <linearGradient id="vd-spark-grad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%"   stop-color="#6366f1" stop-opacity="0.45"/>
                <stop offset="100%" stop-color="#6366f1" stop-opacity="0"/>
              </linearGradient>
              <linearGradient id="vd-spark-line" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%"   stop-color="#6366f1"/>
                <stop offset="50%"  stop-color="#8b5cf6"/>
                <stop offset="100%" stop-color="#06b6d4"/>
              </linearGradient>
            </defs>
            <path class="spark-area" [attr.d]="sparklineAreaPath()" fill="url(#vd-spark-grad)" />
            <path class="spark-line" [attr.d]="sparklinePath()" fill="none" stroke="url(#vd-spark-line)" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="spark-caption">{{ 'accueil.spark.caption' | transloco }}</span>
        </div>
        <ng-template #heroSparkSkeleton>
          <div class="spark-skeleton"></div>
        </ng-template>

        <!-- Period chips dans le hero -->
        <div class="hero-period">
          <button
            *ngFor="let p of periods"
            type="button"
            class="period-btn"
            [class.active]="selectedPeriod() === p.key"
            (click)="setPeriod(p.key)"
          >
            {{ p.labelKey | transloco }}
          </button>
          <button class="refresh-btn" type="button" (click)="refresh()" [class.is-loading]="loading()"
                  [title]="'accueil.period.refresh_title' | transloco"
                  [attr.aria-label]="'accueil.period.refresh_aria' | transloco">
            <span class="material-icons-outlined">{{ loading() ? 'sync' : 'refresh' }}</span>
          </button>
        </div>
      </aside>
    </div>
  </header>

  <!-- ═══════════════════════════════════════════════════════════════════
       2. VIBES DU MOMENT — Pulse timeline + KPI tiles
       ═══════════════════════════════════════════════════════════════════ -->
  <vd-section [title]="'accueil.vibes.title' | transloco" [subtitle]="'accueil.vibes.subtitle' | transloco" icon="trending_up" class="section-enter">

    <!-- Pulse timeline -->
    <div class="pulse-rail" *ngIf="pulseEvents().length > 0; else pulseSkeleton" [attr.aria-label]="'accueil.vibes.pulse_aria' | transloco">
      <button
        *ngFor="let p of pulseEvents()"
        class="pulse-card"
        type="button"
        [attr.data-tone]="p.tone"
        [disabled]="!p.action"
        (click)="triggerPulse(p)"
      >
        <span class="pulse-icon material-icons-outlined">{{ p.icon }}</span>
        <span class="pulse-label">{{ p.label }}</span>
        <span class="pulse-dot" aria-hidden="true"></span>
      </button>
    </div>
    <ng-template #pulseSkeleton>
      <div class="pulse-rail">
        <div class="pulse-card pulse-skeleton" *ngFor="let i of [1,2,3,4]"></div>
      </div>
    </ng-template>

    <!-- KPI grid -->
    <ng-container *ngIf="!loading() || data(); else kpiSkeleton">
      <vd-stat-grid
        [stats]="kpiStats()"
        [cols]="3"
        [interactive]="true"
        (statClick)="onKpiClick($event)"
      ></vd-stat-grid>
    </ng-container>
    <ng-template #kpiSkeleton>
      <div class="kpi-skeleton-grid">
        <app-skeleton kind="card" *ngFor="let i of [1,2,3,4,5,6]"></app-skeleton>
      </div>
    </ng-template>
  </vd-section>

  <!-- Bannière erreur -->
  <vd-card *ngIf="errorMessage() as err" variant="outlined" class="error-banner section-enter">
    <span class="material-icons-outlined">error_outline</span>
    <span>{{ err }}</span>
    <vd-button variant="ghost" size="sm" (click)="refresh()">{{ 'common.retry' | transloco }}</vd-button>
  </vd-card>

  <!-- ═══════════════════════════════════════════════════════════════════
       3. MON ÉCOSYSTÈME 360°
       ═══════════════════════════════════════════════════════════════════ -->
  <vd-section [title]="'accueil.eco.title' | transloco" [subtitle]="'accueil.eco.subtitle' | transloco" icon="grid_view" class="section-enter">
    <div class="eco-grid">

      <!-- Sites -->
      <vd-card variant="default" padding="md" class="eco-card eco-sites">
        <header class="eco-head">
          <div>
            <span class="eco-eyebrow">{{ 'accueil.eco.sites_eyebrow' | transloco }}</span>
            <h3>{{ 'accueil.eco.sites_title' | transloco }}</h3>
          </div>
          <vd-tag tone="primary" [solid]="false">{{ mySites().length }}</vd-tag>
        </header>

        <div class="eco-site-list" *ngIf="mySites().length > 0; else noSites">
          <button
            *ngFor="let s of mySites().slice(0, 3)"
            type="button"
            class="eco-site-row"
            (click)="openSite(s)"
          >
            <div class="eco-site-thumb" aria-hidden="true">
              <span class="material-icons-outlined">language</span>
            </div>
            <div class="eco-site-meta">
              <span class="eco-site-name">{{ s.name }}</span>
              <span class="eco-site-slug">{{ s.slug }}.vendeur.site</span>
            </div>
            <vd-tag [tone]="siteStatusTone(s.status)" [solid]="false">{{ s.status }}</vd-tag>
          </button>
        </div>
        <ng-template #noSites>
          <div class="eco-empty">
            <span class="material-icons-outlined">add_business</span>
            <p>{{ 'accueil.eco.no_sites' | transloco }}</p>
          </div>
        </ng-template>

        <div class="eco-actions">
          <vd-button variant="primary" size="sm" (click)="goToNewSite()">
            <span slot="leading" class="material-icons-outlined" style="font-size: 16px;">add</span>
            {{ 'accueil.eco.new_site' | transloco }}
          </vd-button>
          <vd-button variant="ghost" size="sm" (click)="goToSites()">
            {{ 'accueil.eco.see_all_sites' | transloco }}
            <span slot="trailing" class="material-icons-outlined" style="font-size: 16px;">chevron_right</span>
          </vd-button>
        </div>
      </vd-card>

      <!-- Boutiques -->
      <vd-card variant="default" padding="md" class="eco-card eco-stores">
        <header class="eco-head">
          <div>
            <span class="eco-eyebrow">{{ 'accueil.eco.stores_eyebrow' | transloco }}</span>
            <h3>{{ 'accueil.eco.stores_title' | transloco }}</h3>
          </div>
          <vd-tag tone="info" [solid]="false">{{ myStores().length }}</vd-tag>
        </header>

        <div class="eco-store-list" *ngIf="myStores().length > 0; else noStores">
          <button
            *ngFor="let st of myStores()"
            type="button"
            class="eco-store-row"
            (click)="goToStores()"
          >
            <div class="eco-store-icon" aria-hidden="true">
              <span class="material-icons-outlined">storefront</span>
            </div>
            <div class="eco-store-meta">
              <span class="eco-store-name">{{ st.name }}</span>
              <span class="eco-store-sub">{{ 'accueil.eco.products_count' | transloco: { count: (st.products?.length || 0) } }}</span>
            </div>
            <span class="material-icons-outlined eco-store-chev">chevron_right</span>
          </button>
        </div>
        <ng-template #noStores>
          <div class="eco-empty">
            <span class="material-icons-outlined">storefront</span>
            <p>{{ 'accueil.eco.no_stores' | transloco }}</p>
          </div>
        </ng-template>

        <div class="eco-actions">
          <vd-button variant="ghost" size="sm" (click)="goToStores()" [fullWidth]="true">
            {{ 'accueil.eco.see_all_stores' | transloco }}
            <span slot="trailing" class="material-icons-outlined" style="font-size: 16px;">chevron_right</span>
          </vd-button>
        </div>
      </vd-card>

      <!-- Canaux sociaux -->
      <vd-card variant="default" padding="md" class="eco-card eco-channels">
        <header class="eco-head">
          <div>
            <span class="eco-eyebrow">{{ 'accueil.eco.channels_eyebrow' | transloco }}</span>
            <h3>{{ 'accueil.eco.channels_title' | transloco }}</h3>
          </div>
          <vd-tag [tone]="inboxUnreadCount() > 0 ? 'danger' : 'success'" [solid]="false">
            {{ 'accueil.eco.unread_count' | transloco: { count: inboxUnreadCount() } }}
          </vd-tag>
        </header>

        <div class="channel-grid">
          <button
            *ngFor="let c of channelTiles()"
            type="button"
            class="channel-tile"
            [class.is-soon]="c.comingSoon"
            [attr.data-tone]="c.tone"
            [class.connected]="c.connected"
            (click)="openChannel(c)"
          >
            <span class="material-icons-outlined channel-icon">{{ c.icon }}</span>
            <span class="channel-label">{{ c.label }}</span>
            <span class="channel-state">
              <span class="state-dot" [class.on]="c.connected"></span>
              {{
                (c.comingSoon
                  ? 'marketing.badge_soon'
                  : c.connected
                    ? 'accueil.eco.channel_connected'
                    : 'accueil.eco.channel_to_connect'
                ) | transloco
              }}
            </span>
            <span class="channel-badge" *ngIf="c.unread > 0 && !c.comingSoon">{{ c.unread }}</span>
            <span class="channel-soon-badge" *ngIf="c.comingSoon">{{ 'marketing.badge_soon' | transloco }}</span>
          </button>
        </div>

        <div class="eco-actions">
          <vd-button variant="ghost" size="sm" (click)="goToMessages()" [fullWidth]="true">
            {{ 'accueil.eco.open_inbox' | transloco }}
            <span slot="trailing" class="material-icons-outlined" style="font-size: 16px;">chevron_right</span>
          </vd-button>
        </div>
      </vd-card>

    </div>
  </vd-section>

  <!-- ═══════════════════════════════════════════════════════════════════
       4. INSIGHTS IA
       ═══════════════════════════════════════════════════════════════════ -->
  <vd-section [title]="'accueil.insights.title' | transloco" [subtitle]="'accueil.insights.subtitle' | transloco" icon="auto_awesome" class="section-enter">
    <div class="insights-rail" *ngIf="insights().length > 0; else insightsEmpty">
      <article
        *ngFor="let ins of insights()"
        class="insight-card"
        [attr.data-tone]="ins.tone"
      >
        <div class="insight-icon-wrap">
          <span class="material-icons-outlined">{{ ins.icon }}</span>
        </div>
        <h4 class="insight-title">{{ ins.title }}</h4>
        <p class="insight-body">{{ ins.body }}</p>
        <button class="insight-cta" type="button" (click)="triggerInsight(ins)">
          {{ ins.cta }}
          <span class="material-icons-outlined">arrow_forward</span>
        </button>
      </article>
    </div>
    <ng-template #insightsEmpty>
      <div class="insights-empty">
        <span class="insights-empty-icon material-icons-outlined">auto_awesome</span>
        <p>{{ 'accueil.insights.empty' | transloco }}</p>
      </div>
    </ng-template>
  </vd-section>

  <!-- ═══════════════════════════════════════════════════════════════════
       5. VUES CROISÉES (top clients / produits / canaux)
       ═══════════════════════════════════════════════════════════════════ -->
  <vd-section [title]="'accueil.cross.title' | transloco" [subtitle]="'accueil.cross.subtitle' | transloco" icon="insights" class="section-enter">
    <div class="cross-grid">

      <vd-card variant="default" padding="md" class="cross-card">
        <header class="cross-card-head">
          <div>
            <span class="cross-card-eyebrow">{{ 'accueil.cross.top_customers_eyebrow' | transloco }}</span>
            <h3>{{ 'accueil.cross.top_customers_title' | transloco }}</h3>
          </div>
          <vd-tag tone="primary" [solid]="false">{{ topCustomersCross().length }}</vd-tag>
        </header>
        <vd-empty-state
          *ngIf="topCustomersCross().length === 0"
          icon="people"
          size="sm"
          [title]="'accueil.cross.no_customers_title' | transloco"
          [description]="'accueil.cross.no_customers_desc' | transloco"
        ></vd-empty-state>
        <vd-data-row
          *ngFor="let item of topCustomersCross()"
          [label]="item.label"
          [value]="item.value"
          icon="person"
          [clickable]="true"
          (rowClick)="navigateCross(item)"
        ></vd-data-row>
        <vd-button variant="ghost" size="sm" (click)="goTo('/clients')" [fullWidth]="true" *ngIf="topCustomersCross().length > 0">
          {{ 'accueil.cross.see_all_customers' | transloco }}
          <span slot="trailing" class="material-icons-outlined" style="font-size: 16px;">chevron_right</span>
        </vd-button>
      </vd-card>

      <vd-card variant="default" padding="md" class="cross-card">
        <header class="cross-card-head">
          <div>
            <span class="cross-card-eyebrow">{{ 'accueil.cross.top_products_eyebrow' | transloco }}</span>
            <h3>{{ 'accueil.cross.top_products_title' | transloco }}</h3>
          </div>
          <vd-tag tone="accent" [solid]="false">{{ topProductsCross().length }}</vd-tag>
        </header>
        <vd-empty-state
          *ngIf="topProductsCross().length === 0"
          icon="inventory_2"
          size="sm"
          [title]="'accueil.cross.no_sales_title' | transloco"
          [description]="'accueil.cross.no_sales_desc' | transloco"
        ></vd-empty-state>
        <vd-data-row
          *ngFor="let item of topProductsCross()"
          [label]="item.label"
          [value]="item.value"
          icon="inventory_2"
          [clickable]="true"
          (rowClick)="navigateCross(item)"
        ></vd-data-row>
        <vd-button variant="ghost" size="sm" (click)="goTo('/produits')" [fullWidth]="true" *ngIf="topProductsCross().length > 0">
          {{ 'accueil.cross.see_all_products' | transloco }}
          <span slot="trailing" class="material-icons-outlined" style="font-size: 16px;">chevron_right</span>
        </vd-button>
      </vd-card>

      <vd-card variant="default" padding="md" class="cross-card">
        <header class="cross-card-head">
          <div>
            <span class="cross-card-eyebrow">{{ 'accueil.cross.top_channels_eyebrow' | transloco }}</span>
            <h3>{{ 'accueil.cross.top_channels_title' | transloco }}</h3>
          </div>
          <vd-tag tone="info" [solid]="false">{{ topChannelsCross().length }}</vd-tag>
        </header>
        <vd-empty-state
          *ngIf="topChannelsCross().length === 0"
          icon="forum"
          size="sm"
          [title]="'accueil.cross.no_channels_title' | transloco"
          [description]="'accueil.cross.no_channels_desc' | transloco"
        ></vd-empty-state>
        <vd-data-row
          *ngFor="let item of topChannelsCross()"
          [label]="item.label"
          [value]="item.value"
          icon="chat"
          [clickable]="true"
          (rowClick)="navigateCross(item)"
        ></vd-data-row>
        <vd-button variant="ghost" size="sm" (click)="goTo('/messages')" [fullWidth]="true" *ngIf="topChannelsCross().length > 0">
          {{ 'accueil.cross.open_inbox' | transloco }}
          <span slot="trailing" class="material-icons-outlined" style="font-size: 16px;">chevron_right</span>
        </vd-button>
      </vd-card>

    </div>
  </vd-section>

  <!-- ═══════════════════════════════════════════════════════════════════
       6. REVENUE CHART + FUNNEL
       ═══════════════════════════════════════════════════════════════════ -->
  <section class="main-grid section-enter">

    <vd-card variant="default" padding="md" class="chart-card revenue-card">
      <header class="card-head">
        <div>
          <span class="card-eyebrow">{{ 'accueil.revenue.eyebrow' | transloco }}</span>
          <h2>{{ 'accueil.revenue.title' | transloco }}</h2>
        </div>
        <div class="chart-head-actions">
          <button
            type="button"
            class="chart-toggle-btn"
            [class.is-active]="compareEnabled()"
            (click)="toggleCompare()"
            [title]="'accueil.revenue.compare_title' | transloco"
          >
            <span class="material-icons-outlined">compare_arrows</span>
            <span class="lbl">{{ 'accueil.revenue.compare' | transloco }}</span>
          </button>
          <vd-tag tone="primary" [solid]="true">{{ 'accueil.revenue.live' | transloco }}</vd-tag>
        </div>
      </header>
      <div class="chart-wrap" *ngIf="!loading() && (data()?.revenue_series?.length ?? 0) > 0; else emptyChart">
        <canvas #revenueCanvas></canvas>
      </div>
      <p class="chart-hint" *ngIf="(data()?.revenue_series?.length ?? 0) > 0">
        <span class="material-icons-outlined">touch_app</span>
        {{ 'accueil.revenue.click_hint' | transloco }}
      </p>
      <ng-template #emptyChart>
        <div class="chart-empty">
          <vd-empty-state *ngIf="!loading()" icon="trending_up"
            [title]="'accueil.revenue.empty_title' | transloco"
            [description]="'accueil.revenue.empty_desc' | transloco"></vd-empty-state>
          <app-skeleton *ngIf="loading()" kind="line" [count]="5"></app-skeleton>
        </div>
      </ng-template>
    </vd-card>

    <vd-card variant="default" padding="md" class="chart-card funnel-card funnel-section">
      <header class="card-head">
        <div>
          <span class="card-eyebrow">{{ 'accueil.funnel.eyebrow' | transloco }}</span>
          <h2>{{ 'accueil.funnel.title' | transloco }}</h2>
        </div>
      </header>
      <div class="funnel-bars" *ngIf="!loading() && funnelEntries().length > 0; else emptyFunnel">
        <button
          *ngFor="let entry of funnelEntries(); let i = index"
          type="button"
          class="funnel-bar"
          [attr.data-index]="i"
          [title]="'accueil.funnel.bar_title' | transloco: { status: entry.status, count: entry.count, pct: entry.pct }"
          (click)="drillFunnel(entry)"
        >
          <div class="funnel-bar-head">
            <span class="funnel-bar-status">{{ entry.status }}</span>
            <span class="funnel-bar-count">{{ entry.count }}</span>
          </div>
          <div class="funnel-bar-track">
            <span class="funnel-bar-fill" [style.--pct.%]="entry.pct"></span>
          </div>
          <div class="funnel-bar-foot">
            <span>{{ entry.pct }}%</span>
            <span class="funnel-bar-drill">
              <span class="material-icons-outlined">chevron_right</span>
              {{ 'accueil.funnel.drill' | transloco }}
            </span>
          </div>
        </button>
      </div>
      <ng-template #emptyFunnel>
        <vd-empty-state *ngIf="!loading()" icon="donut_large" size="sm" [title]="'accueil.funnel.empty_title' | transloco"></vd-empty-state>
        <app-skeleton *ngIf="loading()" kind="card"></app-skeleton>
      </ng-template>
    </vd-card>
  </section>

  <!-- Spacer pour ne pas masquer le contenu sous le sticky -->
  <div class="quick-actions-spacer" aria-hidden="true" *ngIf="quickActions().length > 0"></div>

  <!-- ═══════════════════════════════════════════════════════════════════
       7. QUICK ACTIONS — sticky bottom glassmorphism
       ═══════════════════════════════════════════════════════════════════ -->
  <nav *ngIf="quickActions().length > 0" class="quick-actions-bar" [attr.aria-label]="'accueil.quick.aria' | transloco">
    <div class="quick-actions-shimmer" aria-hidden="true"></div>
    <div class="quick-actions">
      <button
        *ngFor="let a of quickActions()"
        type="button"
        class="quick-action"
        [attr.data-tone]="a.tone"
        (click)="triggerQuickAction(a, $event)"
      >
        <span class="material-icons-outlined">{{ a.icon }}</span>
        <span class="qa-label">{{ a.label }}</span>
      </button>
    </div>
  </nav>

</div>
